module.exports = __webpack_public_path__ + "media/images/icons/courses/10-186698d97e3b39d2c2ca5ea9e1a4d96e.svg";